import React, { useContext, useState } from 'react';
import { CiSearch } from "react-icons/ci";
import { Modal, Input } from 'antd';
import { ProductContext } from '../context/productContext';
import { Link } from "react-router-dom";

const SearchBar = () => {
    const [searchOpen, setSearchOpen] = useState(false);
    const { Search } = Input;
    const { products } = useContext(ProductContext);
    const [searchKey, setSearchKey] = useState('');

    const handleSearchSubmit = (e) => {
        e.preventDefault();
    };

    const filteredProducts = products.filter((product) =>
        product.name.toLowerCase().includes(searchKey.toLowerCase())
    );

    return (
        <li>
            <button
                onClick={() => setSearchOpen(true)}
                className="text-2xl hover:text-brandBlue transition"
            >
                <CiSearch />
            </button>

            <Modal
                open={searchOpen}
                onCancel={() => setSearchOpen(false)}
                footer={null}
                closable={false}
                width={"50%"}
                style={{ top: 55 }}
                bodyStyle={{
                    padding: "30px 20px",
                    background: "linear-gradient(90deg, rgba(67,170,214,1) 60%, rgba(0,0,0,1) 100%)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "8px",
                    borderBottomLeftRadius: "0px",
                    borderBottomRightRadius: "0px",
                }}
            >
                <div className="w-full max-w-3xl relative">
                    <form onSubmit={handleSearchSubmit}>
                        <Search
                            placeholder="Search products, categories, brands..."
                            allowClear
                            enterButton="Search"
                            size="large"
                            value={searchKey}
                            onChange={(e) => setSearchKey(e.target.value)}
                            className="overflow-hidden shadow-lg font-outfit"
                        />
                    </form>

                    {searchKey !== '' && products.length > 0 && (
                        <div className="product-searched">
                            {filteredProducts.length > 0 ? (
                                filteredProducts.slice(0, 10).map((product) => (
                                    <div className="product-verticle product-item-mew" key={product.id}>
                                        <Link to={`/product/${product.id}`} onClick={() => { setSearchKey(''); setSearchOpen(false); }}>
                                            <img
                                                src={`${process.env.REACT_APP_SITE_IMAGES}${product.photo}`}
                                                alt={product.name} />
                                            <div className='fix_wdt'>
                                                <h5>{product.name}</h5>
                                                <p>{product.sort_details}</p>
                                            </div>
                                            <div className='rates_rightt'>
                                                {product.previous_price && (
                                                    <strike>${product.previous_price}</strike>
                                                )}
                                                <span className="dis-price">${product.discount_price}</span>
                                            </div>
                                        </Link>
                                    </div>
                                ))
                            ) : (
                                <div className="not_found_wrp">No Products Found</div>
                            )}
                        </div>
                    )}
                </div>
            </Modal>
        </li>
    );
};

export default SearchBar;
